import { cn } from "@newxsystems/shared";
import type { ISproutSectionProps } from "./SproutSection.props";

export const SproutSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: ISproutSectionProps) => (
  <section
    className={cn("sprout-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("sprout-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

SproutSection.displayName = "Content::SproutSection";
